/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { StartAgentRequest, StartAgentResponse } from "../models/index";
import {
  StartAgentRequestFromJSON,
  StartAgentRequestToJSON,
  StartAgentResponseFromJSON,
  StartAgentResponseToJSON,
} from "../models/index";

export interface StartRequest {
  startAgentRequest: StartAgentRequest;
}

/**
 *
 */
export class AgentsApi extends runtime.BaseAPI {
  /**
   */
  async startRaw(
    requestParameters: StartRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<StartAgentResponse>> {
    if (requestParameters["startAgentRequest"] == null) {
      throw new runtime.RequiredError(
        "startAgentRequest",
        'Required parameter "startAgentRequest" was null or undefined when calling start().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/agents/start`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: StartAgentRequestToJSON(requestParameters["startAgentRequest"]),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      StartAgentResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async start(
    requestParameters: StartRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<StartAgentResponse> {
    const response = await this.startRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
